export default "__VITE_ASSET__9ff4ae5b__"